import { LockSolidIcon } from '@contra/icons/icons';
import { css, styled } from 'styled-components';

const Container = styled.div<{ $size: 'md' | 'sm' }>`
  ${({ $size }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ddd8ff;
    border-radius: 50%;
    width: ${$size === 'sm' ? 32 : 56}px;
    height: ${$size === 'sm' ? 32 : 56}px;
    color: #6a57e366;
  `}
`;

type LockedAvatarProps = {
  readonly size?: 'md' | 'sm';
};

export const LockedAvatar = ({ size = 'md' }: LockedAvatarProps) => {
  return (
    <Container $size={size}>
      <LockSolidIcon size={size === 'md' ? 22 : 13} />
    </Container>
  );
};
